var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C24.8369 0 32 7.16313 32 16C32 24.8369 24.8369 32 16 32C7.16313 32 0 24.8369 0 16C0 7.16313 7.16313 0 16 0ZM8.8725 23.4256H11.9369V13.525H8.8725V23.4256ZM10.39 12.2288C11.3913 12.2288 12.2025 11.41 12.2025 10.4012C12.2025 9.3925 11.3913 8.57438 10.39 8.57438C9.38875 8.57438 8.57812 9.3925 8.57812 10.4012C8.57812 11.41 9.38875 12.2288 10.39 12.2288ZM16.8356 18.2288C16.8356 16.8369 17.4769 16.0069 18.7038 16.0069C19.83 16.0069 20.3719 16.8031 20.3719 18.2288C20.3719 19.6544 20.3719 23.4256 20.3719 23.4256H23.4219C23.4219 23.4256 23.4219 19.8088 23.4219 17.1569C23.4219 14.505 21.9187 13.2225 19.8194 13.2225C17.7194 13.2225 16.8356 14.8588 16.8356 14.8588V13.525H13.8962V23.4256H16.8356C16.8356 23.4256 16.8356 19.7537 16.8356 18.2288Z",
    fill: "#6E7E9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.30ff3191c5463c08c641ba6f7116cff4.svg";
export { ForwardRef as ReactComponent };